import { useMemo } from 'react';
import { useNavigation } from 'react-router';
import type { SearchCategory, SelectableItem } from '~/features/catalog/components/navigation/CategoryNavigation';
import { useBasePath } from '~/common/hooks/useBasePath';
import {
  QUERY_SEARCH_PARAM_CATALOG_AGRID,
  QUERY_SEARCH_PARAM_CATALOG_HAGRID,
  QUERY_SEARCH_PARAM_CATALOG_HWGID
} from '~/features/catalog/mappers/catalogSearchQueryMapper';

export function useIsNavigatingToCategory({
  selectableCategory
}: {
  selectableCategory: SelectableItem<SearchCategory>;
}) {
  const navigation = useNavigation();
  const { path } = useBasePath();

  const isNavigatingToCategory = useMemo(() => {
    if (navigation.location?.pathname !== `${path}/catalog`) {
      return false;
    }

    const isNavigating = navigation.state === 'loading';

    let isNavi = false;
    if (isNavigating) {
      const searchParams = new URLSearchParams(navigation.location?.search ?? '');
      const cHwgId = searchParams.get(QUERY_SEARCH_PARAM_CATALOG_HWGID);
      const cHagrId = searchParams.get(QUERY_SEARCH_PARAM_CATALOG_HAGRID);
      const cAgrId = searchParams.get(QUERY_SEARCH_PARAM_CATALOG_AGRID);

      if (
        (selectableCategory.item.path.hwgId?.toString() ?? null) === cHwgId &&
        (selectableCategory.item.path.hagrId?.toString() ?? null) === cHagrId &&
        (selectableCategory.item.path.agrId?.toString() ?? null) === cAgrId
      ) {
        isNavi = true;
      }
    }
    return isNavi;
  }, [
    navigation.location?.pathname,
    navigation.location?.search,
    navigation.state,
    path,
    selectableCategory.item.path.agrId,
    selectableCategory.item.path.hagrId,
    selectableCategory.item.path.hwgId
  ]);

  return { isNavigatingToCategory };
}
